import { render, staticRenderFns } from "./cart_items.vue?vue&type=template&id=6af7b30d"
import script from "./cart_items.vue?vue&type=script&lang=js"
export * from "./cart_items.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/johnmartin/Repos/whitefox-shopify-theme/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6af7b30d')) {
      api.createRecord('6af7b30d', component.options)
    } else {
      api.reload('6af7b30d', component.options)
    }
    module.hot.accept("./cart_items.vue?vue&type=template&id=6af7b30d", function () {
      api.rerender('6af7b30d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/cart_items.vue"
export default component.exports